import $ from 'jquery';

import imagesLoaded from 'imagesloaded';
import SiteHeader from "./components/site-header";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import ScrollInView from "./components/scroll-in-view";
import DeviceManager from "./utils/device-manager";
import TextSlider from './components/text-slider';

import { initializeSearchToggle } from "./components/search-toggle";
import './components/gallery';

$(function () {
	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);
		
		initializeSearchToggle();

		// Text slider component
		const $textSliders = $(".text-image-section__slider");
		if ($textSliders.length) {
			$textSliders.each(function (index, el) {
				const textSlider = new TextSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = '';
			switch(document.documentElement.lang) {
				case 'fr-FR':
				tarteaucitronLang = 'fr';
				break;
				default:
					tarteaucitronLang = 'fr';
			}

			const cookiesConsent = new CookiesConsent(tarteaucitronLang, false);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	}

	bootstrapApp();
	instanciateComponents();

});



